import styled from "styled-components";
import { Divider as PrimeReactDivider } from 'primereact/divider';

interface CustomDividerProps {
  $margin?: number;
  $color?: string;
  $opacity?: number;
}

export const Divider = styled(PrimeReactDivider)<CustomDividerProps>`
  color: ${(props) => props.$color || props.theme.palette.divider.primary};
  margin: ${(props) => `${props.$margin || 20}px`} 0;
  opacity: ${(props) => props.$opacity || 1};
`;
